export default __webpack_public_path__ + "static/media/back.4e854c7c.jpg";